
const PROJECT_NAMESPACE = 'project'
const PROJECT_COMMITS =  {
    // 新建项目
    NEW: 'NEW',
    // 编辑字段
    EDIT: 'EDIT',
    TOP_PROJECT_ID:'TOP_PROJECT_ID',
    CLEAN: 'CLEAN',
    // 保存项目
    PERSISTENT: 'PERSISTENT',
    //更新节点
    UPDATE_NODES: 'UPDATE_NODES',
    //设置入库状态
    SET_REVIEW: 'SET_REVIEW',
}
const PROJECT_DISPATCHS = {
    //新建项目
    NEW:'NEW',
    //打开项目
    OPEN: 'OPEN',
    //关闭项目
    CLOSE: 'CLOSE',
    //加载总项目
    LOAD:'LOAD',
    //加载子项
    LOAD_PROJECT:'LOAD_PROJECT',
    //保存项目
    SAVE: 'SAVE',
    //移除项目
    REMOVE: 'REMOVE',
    
    //新增项目节点
    ADD_NODE: 'ADD_NODE',
    //删除项目节点
    REMOVE_NODE: 'REMOVE_NODE',
    //移动项目节点
    MOVE_NODE: 'MOVE_NODE',
    //项目设置    
    SETTING: 'SETTING',    
    //设置指标方案
    SET_INDICATRIX_SCHEMA: 'SET_INDICATRIX_SCHEMA',
    //审核入库
    REVIEW: 'REVIEW',
}



const CONFIG_NAMESPACE = 'config'
const CONFIG_COMMITS={
    PUT: 'PUT'
}

const CONFIG_DISPATCHS={
    LOAD: 'LOAD',
    LOAD_BY_TYPE: 'LOAD_BY_TYPE'
}

const CONFIG_CATEGORIES={
    ENTITIES: 'entities',
    PROJECT_TYPES: 'projectTypes'
}

const INDICATRIX_NAMESPACE = 'indicatrix'
const INDICATRIX_COMMITS={
    INIT: 'INIT',
    EDIT: 'EDIT',
    PUT: 'PUT',
    SET_VIEW: 'SET_VIEW',
    PERSISTENT: 'PERSISTENT',
    SET_SCHEMA: 'SET_SCHEMA',
    CLEAN: 'CLEAN',
    RECYCLE: 'RECYCLE',
}
const INDICATRIX_DISPATCHS={
    SAVE: 'SAVE',
    LOAD: 'LOAD',
    LOAD_SCHEMA: 'LOAD_SCHEMA',
    BUILD_VIEW_DATA: 'BUILD_VIEW_DATA',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
}
const SAVER_NAMESPACE = 'saver'
const SAVER_COMMITS={
    REQUIRE_SAVE:'REQUIRE_SAVE',
    CANCEL_SAVE:'CANCEL_SAVE'
}
const SAVER_DISPATCHS={
    SUBMIT:'SUBMIT'
}

const PALLET_NAMESPACE = 'pallet'
const PALLET_COMMITS={
    ADD_TRAY:'ADD_TRAY',
    REMOVE_TRAY:'REMOVE_TRAY'
}
const TROLLEY_NAMESPACE = 'trolley'
const TROLLEY_COMMITS={
    PUT_IN:'PUT_IN',
    TAKE_OUT:'TAKE_OUT'
}

const VIEW_NAMESPACE = 'view'
const VIEW_DISPATCHS={
    LOAD_VIEW:'LOAD_VIEW',
    LOAD_VIEWS:'LOAD_VIEWS'
}
const SEARCH_NAMESPACE = 'search'
const SEARCH_COMMITS={
    NEW_SEARCH:'NEW_SEARCH',
    REMOVE_SEARCH:'REMOVE_SEARCH',
    ACTIVE_SEARCH:'ACTIVE_SEARCH',
}
const SEARCH_DISPATCHS={
    LOAD_RESULT:'LOAD_RESULT',
}
export {
    PROJECT_NAMESPACE,
    PROJECT_COMMITS,
    PROJECT_DISPATCHS,

    CONFIG_NAMESPACE,
    CONFIG_COMMITS,
    CONFIG_DISPATCHS,
    CONFIG_CATEGORIES,

    INDICATRIX_NAMESPACE,
    INDICATRIX_COMMITS,
    INDICATRIX_DISPATCHS,

    SAVER_NAMESPACE,
    SAVER_COMMITS,
    SAVER_DISPATCHS,
    
    PALLET_NAMESPACE,
    PALLET_COMMITS,

    TROLLEY_NAMESPACE,
    TROLLEY_COMMITS,
    
    VIEW_NAMESPACE,
    VIEW_DISPATCHS,
    
    SEARCH_NAMESPACE,
    SEARCH_COMMITS,
    SEARCH_DISPATCHS
}